import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { uploadReset, updateDoc } from "../../redux/Actions/SingleUserActions";
import UserNav from "../../components/UserNav/UserNav";
import Sidebar from "../../components/Sidebar/Sidebar";
import { getDocs, getRequiredDocs, getUserStatus } from "../../redux/Actions/GetDocsActions";
import { useHistory } from "react-router-dom";
import Alert from "../../utils/Alert";
import POSRequirement from "../Certification/POSRequirement";
import UserStatus from "../../components/Certification/UserStatus";
import DocsUpload from "../Certification/DocsUpload";
import checkDocs from "../../utils/Functions/CheckCategory";
import assign from "../../utils/Functions/AssignObj";
import UpdateArray from "../../utils/Functions/UpdateArray";
import Spinner from "react-spinner-material";
import Storage from "../../utils/storage";
import { PropTypes } from "prop-types";

const PosAppUpdate = (props) => {
  const {
    getDocsList,
    appStatus,
    isUploading,
    uploadSuccess,
    uploadDocs,
    docs,
    isFetching,
    requiredDocs,
    getRequiredDocs,
    isFetchingRequiredDocs,
    getRequiredDocsSuccess
  } = props;
  const history = useHistory();

  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let categoryChoice = user && user.category_id;

  const singlePosApp = props.location.state;

  const [state, setState] = useState({
    openModal: false,
    fileResult: {},
    allResult: [],
    errorMessage: "",
    items: [],
    document: [],
    inputValue: "",
  });

  useEffect(
    () => {
      const type = "application"
      getRequiredDocs(type)
    },
    // eslint-disable-next-line
    [getRequiredDocs]
  );

  const userAppStatus2 = singlePosApp && singlePosApp.status;
  const userAppStatus = singlePosApp && singlePosApp.nibss_super_admin_status;
  const userAppId = singlePosApp && singlePosApp.id;

  useEffect(
    () => {
      if (getRequiredDocsSuccess) {
        const type = "certification";
        getDocsList(type);
      }
    },
    // eslint-disable-next-line
    [getRequiredDocsSuccess, getDocsList]
  );

  const categoryDocs = requiredDocs && requiredDocs[categoryChoice] && requiredDocs[categoryChoice].documents

  const uploadedDocs = docs && docs[0] && docs[0].documents;
  const filteredUploadedDocs =
    uploadedDocs &&
    uploadedDocs.filter(
      (item) =>
        item.id === 1 ||
        item.id === 30 ||
        item.id === 31 ||
        item.id === 32 ||
        item.id === 33 ||
        item.id === 34
    );

  checkDocs(categoryDocs, filteredUploadedDocs);

  function handleDataFetch(fileResult) {
    if (filteredUploadedDocs && filteredUploadedDocs.length > 0) {
      let allResult = uploadedDocs;
      setState({
        allResult,
      });
      UpdateArray(allResult, fileResult);
      setState({ allResult });
    } else {
      let allResult = [...state.allResult];
      UpdateArray(allResult, fileResult);
      setState({ allResult });
    }
  }

  const handleRemoval = (fileResult) => {
    state.allResult &&
      state.allResult.splice(
        state.allResult.findIndex((item) => item.id === fileResult.id),
        1
      );
    setState(JSON.parse(JSON.stringify(state)));
    return state.allResult
  };

  const checkingStatus =
    docs &&
    docs.length > 0 &&
    filteredUploadedDocs &&
    filteredUploadedDocs.length > 0;

  const uploadAppDocs = () => {
    let allFiles = [];
    const data =
      state.allResult &&
      state.allResult.filter(
        (item) =>
          item.id === 1 ||
          item.id === 30 ||
          item.id === 31 ||
          item.id === 32 ||
          item.id === 33 ||
          item.id === 34
      );
    assign(data, allFiles);

    const files = {
      application_id: userAppId && userAppId.toString(),
      application_type: "pos_application_certification",
      document: allFiles,
    };
    uploadDocs(files);
  };

  const disable =
    state.allResult &&
    state.allResult.filter(
      (item) =>
        item.id === 30 ||
        item.id === 31 ||
        item.id === 32 ||
        item.id === 33 ||
        item.id === 34
    ).length < 5;

  const disable2 =
    state.allResult &&
    state.allResult.filter(
      (item) =>
        item.id === 1 ||
        item.id === 30 ||
        item.id === 31 ||
        item.id === 32 ||
        item.id === 33 ||
        item.id === 34
    ).length < 6;

  useEffect(
    () => {
      if (uploadSuccess) {
        state.errorMessage = "";
        Alert(
          true,
          "success",
          "Success message",
          "Your application has been updated for review."
        );
        history.push({
          pathname: "/dashboard",
        });
        setState({
          ...state,
          errorMessage: "",
        });
      }
    },
    // eslint-disable-next-line
    [uploadSuccess]
  );

  return (
    <div className="container">
      <UserNav />
      <Sidebar />

      <main className="container-body">
        <UserStatus
          userAppStatus={userAppStatus}
          userAppStatus2={userAppStatus2}
          appStatus={appStatus}
        />

        <div className="upload-flex">
          <div className="upload-title">
            <h2>POS Application Certification Documents</h2>
            <p>
              The documents we ask for are based on your certification selection
            </p>
            <p>
              (Only pdf, png, jpeg and jpg formats are allowed with a max file
              size of 5MB)
            </p>
          </div>

          <POSRequirement type="application" />
        </div>

        {isFetchingRequiredDocs ? (
          <div className="center-spinner2">
            <br />
            <Spinner
              size={120}
              color={"#047558"}
              spinnerwidth={5}
              visible={true}
            />
          </div>
        ) : (
            getRequiredDocsSuccess && (
              <DocsUpload
                categoryDocs={categoryDocs}
                upload={uploadAppDocs}
                disabled={
                  checkingStatus
                    ? disable === true
                    : disable2 === true || isUploading
                }
                isUploading={isUploading}
                handleDataFetch={handleDataFetch}
                handleRemoval={handleRemoval}
                isFetching={isFetching}
                text={"UPDATE"}
              />
            )
          )}
      </main>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isUploading: state.singleUser.isUpdating,
    uploadSuccess: state.singleUser.updateSuccess,
    uploadedDoc: state.pos.renewal,
    docs: state.docs.docs,
    appStatus: state.docs.status,
    isFetching: state.docs.isFetching,
    isGetting: state.docs.isGetting,
    getStatusSuccess: state.docs.getStatusSuccess,
    isFetchingRequiredDocs: state.docs.isGettingDocs,
    requiredDocs: state.docs.requiredDocs,
    getRequiredDocsSuccess: state.docs.getRequiredDocsSuccess
  };
};

const mapDispatchToProps = (dispatch) => ({
  uploadDocs: (payload) => dispatch(updateDoc(payload)),
  getDocsList: (type) => dispatch(getDocs(type)),
  getStatus: () => dispatch(getUserStatus()),
  uploadReset: () => dispatch(uploadReset()),
  getRequiredDocs: (type) => dispatch(getRequiredDocs(type)),
});

PosAppUpdate.propTypes = {
  appStatus: PropTypes.array,
  docs: PropTypes.array,
  getDocsList: PropTypes.func,
  getRequiredDocs: PropTypes.func,
  getRequiredDocsSuccess: PropTypes.bool,
  getStatusSuccess: PropTypes.bool,
  isFetching: PropTypes.bool,
  isFetchingRequiredDocs: PropTypes.bool,
  isGetting: PropTypes.bool,
  isUploading: PropTypes.bool,
  location: PropTypes.shape({
    state: PropTypes.shape({
      id: PropTypes.number,
      nibss_super_admin_status: PropTypes.string,
      status: PropTypes.string
    })
  }),
  requiredDocs: PropTypes.object,
  uploadDocs: PropTypes.func,
  uploadSuccess: PropTypes.bool
}

export default connect(mapStateToProps, mapDispatchToProps)(PosAppUpdate);
